module.exports = __webpack_public_path__ + "img/potted-1.f9e982b2.jpeg";